import React, { useState, useEffect, useMemo } from "react";

import Card from "../../components/Card";
import BarChartStatic from "../../components/BarChartStatic";
import DatePickerFilter from "../../components/DatePickerFilter";
import DonutChart from "../../components/DonutChart";



const StatisticScreen = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const COLORS = ["#5d55e8", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"];

  useEffect(() => {
    const mockData = Array.from({ length: 60 }).map((_, i) => ({
      country: i % 3 === 0 ? "Tunisia" : i % 3 === 1 ? "Morocco" : "Senegal",
      transfersCount: Math.floor(Math.random() * 10),
      amount: Math.floor(Math.random() * 500) + 50,
      createdAt: `2026-03-${(i % 28) + 1}`,
    }));

    setTimeout(() => {
      setData(mockData);
      setLoading(false);
    }, 800);
  }, []);

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const created = new Date(item.createdAt);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      return (!start || created >= start) && (!end || created <= end);
    });
  }, [data, startDate, endDate]);

  const stats = useMemo(() => {
    const statusCounts = {};
    const countryCounts = {};
    let totalVolume = 0;

    filteredData.forEach((c) => {
      const status =
        c.transfersCount >= 5
          ? "VIP"
          : c.transfersCount > 0
          ? "Actif"
          : "En attente";
      statusCounts[status] = (statusCounts[status] || 0) + 1;
      countryCounts[c.country] = (countryCounts[c.country] || 0) + 1;
      totalVolume += c.amount;
    });

    return {
      bar: Object.keys(statusCounts).map((k) => ({
        name: k,
        value: statusCounts[k],
      })),
      pie: Object.keys(countryCounts).map((k) => ({
        name: k,
        value: countryCounts[k],
      })),
      totalVolume,
      totalClients: filteredData.length,
    };
  }, [filteredData]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 bg-slate-50 min-h-screen">
      <div className="flex flex-col md:flex-row justify-between items-center mb-10 gap-4">
        <div>
          <h1 className="text-3xl font-black text-slate-800 tracking-tighter uppercase">
            Reporting Statistiques 📊
          </h1>
          <p className="text-slate-400 font-medium">
            Analyse des flux et performances destinations
          </p>
        </div>

        <DatePickerFilter
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        <Card
          title="Volume Global"
          value={`${stats.totalVolume.toLocaleString()} €`}
          icon="💰"
          colorClass="bg-green-50 text-green-600"
        />
        <Card
          title="Clients Total"
          value={stats.totalClients}
          icon="👥"
          colorClass="bg-indigo-50 text-indigo-600"
        />
        <Card
          title="Panier Moyen"
          value={`${(stats.totalVolume / (stats.totalClients || 1)).toFixed(
            0
          )} €`}
          icon="📈"
          colorClass="bg-orange-50 text-orange-600"
        />
        <Card
          title="Objectif"
          value="78%"
          icon="🎯"
          colorClass="bg-rose-50 text-rose-600"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm">
          <h2 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-8 text-center">
            📊 Pipeline Clients
          </h2>
          <div className="h-80">
            <BarChartStatic data={stats.bar} barSize={50} />
          </div>
        </div>

        <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm">
          <h2 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-8 text-center">
            🌍 Parts par Destination (%)
          </h2>
          <div className="h-80">
            <DonutChart data={stats.pie} colors={COLORS} />
          </div>
        </div>
      </div>

      <div className="mt-10 p-6 bg-[#5d55e8] rounded-3xl text-white flex justify-between items-center shadow-lg shadow-indigo-200">
        <div>
          <p className="text-xs font-bold opacity-70 uppercase tracking-widest">
            Objectif du mois
          </p>
          <h3 className="text-xl font-black">
            Atteindre 500 transferts valides
          </h3>
        </div>
        <div className="text-4xl font-black opacity-30">82%</div>
      </div>
    </div>
  );
};

export default StatisticScreen;
